var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._b(
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "loading-wrap active",
      },
      "div",
      _vm.$attrs,
      false
    ),
    [
      _c("svg-icon", {
        attrs: { "class-name": "liveTypeicon", "icon-class": "_wating" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }